import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const PAGE_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'Page',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Page',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Page',
    column_type: 'datetime',
  },
  slug: {
    model_name: 'Page',
    column_type: 'string',
  },
  title: {
    model_name: 'Page',
    column_type: 'string',
  },
  type: {
    model_name: 'Page',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  application: {
    model_name: 'Page',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  application_id: {
    model_name: 'Page',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
    },
  },
  status: {
    model_name: 'Page',
    column_type: 'enum',
  },
  views_count: {
    model_name: 'Page',
    column_type: 'integer',
  },
  mini_program_path: {
    model_name: 'Page',
    column_type: 'string',
  },
  wxacode: {
    model_name: 'Page',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  wxacode_with_audio: {
    model_name: 'Page',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  content: {
    model_name: 'Page',
    column_type: 'text',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
